import { render, staticRenderFns } from "./GroupEditDialog.vue?vue&type=template&id=2ae8c4de&"
import script from "./GroupEditDialog.vue?vue&type=script&lang=ts&"
export * from "./GroupEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports